import { ReactElement } from 'react';
import { Badge, BadgeProps } from '@fluentui/react-components';
import { CheckmarkCircleRegular, CircleRegular, ClockRegular, WarningRegular } from '@fluentui/react-icons';

import { SECTION_STATUS, TSectionStatus } from '../../models';

const STATUS_META: Record<TSectionStatus, { color: BadgeProps['color']; icon: ReactElement }> = {
  [SECTION_STATUS.NOT_STARTED]: { color: 'subtle', icon: <CircleRegular /> },
  [SECTION_STATUS.IN_PROGRESS]: { color: 'warning', icon: <ClockRegular /> },
  [SECTION_STATUS.NEEDS_INPUT]: { color: 'danger', icon: <WarningRegular /> },
  [SECTION_STATUS.COMPLETE]: { color: 'success', icon: <CheckmarkCircleRegular /> },
};

type TProps = {
  status: TSectionStatus;
  size?: BadgeProps['size'];
  className?: string;
};

// Mirrors the dashboard status treatment: a tinted Fluent UI badge with both
// an icon and text, so section status never depends on color or position alone.
export const SectionStatusBadge = ({ status, size = 'small', className }: TProps) => {
  const meta = STATUS_META[status];
  return (
    <Badge appearance="tint" color={meta.color} size={size} icon={meta.icon} className={className}>
      {status}
    </Badge>
  );
};
